import React from 'react';

const loadingMessages = [
  'Brewing some code...',
  'Summoning data wizards...',
  'Polishing bits and bytes...',
  'Loading magical contents...',
  'Crafting your experience...',
  'Warming up the servers...',
  'Preparing awesome things...',
  'Charging quantum computers...',
  'Unleashing digital ninjas...',
  'Syncing with the matrix...'
];

const Loading: React.FC = () => {
  const randomMessage = loadingMessages[Math.floor(Math.random() * loadingMessages.length)];

  return (
    <div className="fixed inset-0 bg-gray-100 flex items-center justify-center z-50">
      <div className="flex flex-col items-center">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid"></div>
        <p className="mt-4 text-xl text-gray-700">{randomMessage}</p>
      </div>
    </div>
  );
};

export default Loading;